/* eslint-disable react/prop-types */
import React from 'react';
import SidebarRow from "../SidebarRow/SidebarRow";
import Payment from "../../../../components/Payment";
import { _ApplicationSection } from "../styles";
var SidebarApplicationSection = function SidebarApplicationSection(_ref) {
  var permissions = _ref.permissions,
    applicationFee = _ref.applicationFee,
    appPrice = _ref.appPrice,
    extraCharges = _ref.extraCharges,
    info = _ref.info;
  return /*#__PURE__*/React.createElement(_ApplicationSection, null, /*#__PURE__*/React.createElement(SidebarRow, {
    title: "Payment",
    key: "student-sidebar-payment",
    content: /*#__PURE__*/React.createElement(Payment, {
      applicationFee: applicationFee,
      appPrice: appPrice,
      extraCharges: extraCharges,
      info: info,
      permissions: permissions
    })
  }));
};
export default SidebarApplicationSection;